import { render, staticRenderFns } from "./bubble_pop.config.vue?vue&type=template&id=7c374868&scoped=true"
import script from "./bubble_pop.config.vue?vue&type=script&lang=js"
export * from "./bubble_pop.config.vue?vue&type=script&lang=js"
import style0 from "./bubble_pop.config.vue?vue&type=style&index=0&id=7c374868&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c374868",
  null
  
)

export default component.exports